import {
  IdentitiesQuery,
  IdentityFragment,
  useIdentitiesQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useIdentities = withStandardListHook<
  IdentitiesQuery,
  IdentityFragment,
  'identities'
>(useIdentitiesQuery, 'identities');
